import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SessionService } from '@shared/services/session.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({providedIn: 'root'})
export class AuthGuardService  {

  constructor(private sessionService: SessionService,
              @Inject(PLATFORM_ID) private platformId: string) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    if (!this.sessionService.$sessionInfo.value && isPlatformBrowser(this.platformId)) {
      this.sessionService.signOut(state.url);
      this.sessionService.loginRequired$.next();
      return false;
    }
    return true;
  }
}
